<template>
    <a href="#" @click.prevent="scrollTo" class="cursor-pointer">
        <slot />
    </a>
</template>

<script setup>
const props = defineProps({
    target: { type: String, required: true },
});

const scrollTo = () => {
    const el = document.querySelector(props.target);
    if (el) {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
</script>
